import { FilterCategoryItemProps, SwitchFilterConfig } from '@/components/data-table/filters-v2';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Switch } from '@/components/ui/switch';

/**
 * Flat row (not a submenu) rendering a boolean switch directly in the filter dropdown.
 *
 * Off-state semantics depend on `hiddenFromSummary`:
 * - Normal switch: toggling off clears the filter param entirely.
 * - `hiddenFromSummary` switch (e.g. "Hide archived"): toggling off persists an
 *   explicit `'false'` so an absent value can be treated as the default-ON state.
 */
export function SwitchFilterRow({
  config,
  activeValues,
  onFilterChange,
}: FilterCategoryItemProps & {
  config: SwitchFilterConfig;
}) {
  const checked = activeValues[0] === 'true';

  const handleChange = (next: boolean) => {
    if (next) {
      onFilterChange(config.name, ['true']);
    } else {
      // Hidden-from-summary switches default to ON when absent, so an explicit
      // OFF must be persisted as 'false' rather than cleared.
      onFilterChange(config.name, config.hiddenFromSummary ? ['false'] : []);
    }
  };

  return (
    <DropdownMenuItem
      // Keep the dropdown open while toggling
      onSelect={e => e.preventDefault()}
      className="flex cursor-pointer items-center justify-between gap-2"
    >
      <span>{config.label}</span>
      <Switch checked={checked} onCheckedChange={handleChange} />
    </DropdownMenuItem>
  );
}
